import React, { useState, useEffect, useRef } from 'react';
import "./App.css";

const canvasEffectForEraser = (canvas, color, cache, setCanvasCache, r) => {

    const ctx = canvas.getContext("2d");
    let isDrawing = false;
    const handleMouseDown = (e) => {
        isDrawing = true;
    }
    const handleMouseUp = () => {
        isDrawing = false;
        setCanvasCache([...cache, ctx.getImageData(0, 0, 1000, 500)]);
    }
    // const handleMouseLeave = () => {
    //     isDrawing = false;
    // }
    const handleMouseMove = ({ offsetX, offsetY }) => {
        if (isDrawing) {
            ctx.clearRect(offsetX - r, offsetY - r, 2 * r, 2 * r);
        }
    }

    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("mousemove", handleMouseMove);
    // canvas.addEventListener("mouseleave", handleMouseLeave);
    return () => {
        console.log("cleared");
        canvas.removeEventListener("mousedown", handleMouseDown);
        canvas.removeEventListener("mouseup", handleMouseUp);
        canvas.removeEventListener("mousemove", handleMouseMove);
        //canvas.removeEventListener("mouseleave", handleMouseLeave);
    }
}
// const canvasEffectForPenCil = (canvas, mode, color, setPath, setPaths, paths) => {
//     const ctx = canvas.getContext("2d");
//     let isDrawing = false;
//     let path = { pts: [], color: color, minX: 10000, minY: 10000, maxX: -1, maxY: -1 };
//     const handleMouseDown = (e) => {
//         ctx.beginPath();
//         ctx.strokeStyle = color;
//         ctx.lineWidth = 1;
//         ctx.moveTo(e.offsetX, e.offsetY);

//         isDrawing = true;
//     }
//     const handleMouseUp = () => {
//         isDrawing = false;
//         console.log(path);
//         const path_ = { pts: [...path.pts], color: color, minX: path.minX, minY: path.minY, maxX: path.maxX, maxY: path.maxY };
//         setPath(path_);
//         setPaths([...paths, path_]);
//         //redrawPath(ctx, path_);
//         path.pts = [];
//     }
//     const handleMouseLeave = () => {
//         isDrawing = false;
//     }
//     const handleMouseMove = (e) => {
//         if (isDrawing) {
//             ctx.lineTo(e.offsetX, e.offsetY);
//             ctx.stroke();
//             path.pts.push({ x: e.offsetX, y: e.offsetY });
//             if (e.offsetX > path.maxX) {
//                 path.maxX = e.offsetX;
//             }
//             if (e.offsetY > path.maxY) {
//                 path.maxY = e.offsetY;
//             }
//             if (e.offsetX < path.minX) {
//                 path.minX = e.offsetX;
//             }
//             if (e.offsetY < path.minY) {
//                 path.minY = e.offsetY;
//             }
//         }
//     }

//     canvas.addEventListener("mousedown", handleMouseDown);
//     canvas.addEventListener("mouseup", handleMouseUp);
//     canvas.addEventListener("mousemove", handleMouseMove);
//     canvas.addEventListener("mouseleave", handleMouseLeave);
//     return () => {
//         console.log("cleared");
//         canvas.removeEventListener("mousedown", handleMouseDown);
//         canvas.removeEventListener("mouseup", handleMouseUp);
//         canvas.removeEventListener("mousemove", handleMouseMove);
//         canvas.removeEventListener("mouseleave", handleMouseLeave);
//     }
// }

const canvasEffectForRectangle = (canvas, color, cache, setCanvasCache) => {
    const ctx = canvas.getContext("2d");
    let isDrawing = false;
    let [x0, y0] = [undefined, undefined];
    const handleMouseDown = (e) => {
        ctx.beginPath();
        ctx.strokeStyle = color;
        ctx.lineWidth = 1;
        ctx.moveTo(e.offsetX, e.offsetY);
        x0 = e.offsetX;
        y0 = e.offsetY;
        isDrawing = true;
    }
    const handleMouseMove = ({ offsetX, offsetY }) => {
        if (isDrawing) {
            ctx.putImageData(cache[cache.length - 1], 0, 0);
            ctx.strokeRect(x0, y0, offsetX - x0, offsetY - y0);
        }
    }
    const handleMouseUp = ({ offsetX, offsetY }) => {
        isDrawing = false;
        setCanvasCache([...cache, ctx.getImageData(0, 0, 1000, 500)]);
    }
    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("mousemove", handleMouseMove);
    return () => {
        console.log("cleared");
        canvas.removeEventListener("mousedown", handleMouseDown);
        canvas.removeEventListener("mouseup", handleMouseUp);
        canvas.removeEventListener("mousemove", handleMouseMove);
    }
}
const canvasEffectForLine = (canvas, color, cache, setCanvasCache) => {
    const ctx = canvas.getContext("2d");
    let isDrawing = false;
    let [x0, y0] = [undefined, undefined];
    const handleMouseDown = (e) => {

        x0 = e.offsetX;
        y0 = e.offsetY;
        isDrawing = true;
    }
    const handleMouseMove = ({ offsetX, offsetY }) => {
        if (isDrawing) {
            ctx.putImageData(cache[cache.length - 1], 0, 0);
            ctx.beginPath();
            ctx.strokeStyle = color;
            ctx.lineWidth = 1;
            ctx.moveTo(x0, y0);
            ctx.lineTo(offsetX, offsetY);
            ctx.stroke();
        }
    }
    const handleMouseUp = ({ offsetX, offsetY }) => {
        isDrawing = false;
        setCanvasCache([...cache, ctx.getImageData(0, 0, 1000, 500)]);
    }
    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("mousemove", handleMouseMove);
    return () => {
        console.log("cleared");
        canvas.removeEventListener("mousedown", handleMouseDown);
        canvas.removeEventListener("mouseup", handleMouseUp);
        canvas.removeEventListener("mousemove", handleMouseMove);
    }
}
const canvasEffectForCircle = (canvas, color, cache, setCanvasCache) => {
    const ctx = canvas.getContext("2d");
    let isDrawing = false;
    let [x0, y0] = [undefined, undefined];
    const handleMouseDown = (e) => {

        x0 = e.offsetX;
        y0 = e.offsetY;
        isDrawing = true;
    }
    const handleMouseMove = ({ offsetX, offsetY }) => {
        if (isDrawing) {
            ctx.putImageData(cache[cache.length - 1], 0, 0);
            ctx.beginPath();
            ctx.strokeStyle = color;
            ctx.lineWidth = 1;
            ctx.ellipse(x0, y0, Math.abs(offsetX - x0), Math.abs(offsetY - y0), 0, 0, 2 * Math.PI);
            ctx.stroke();
        }
    }
    const handleMouseUp = ({ offsetX, offsetY }) => {
        isDrawing = false;
        setCanvasCache([...cache, ctx.getImageData(0, 0, 1000, 500)]);
    }
    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("mousemove", handleMouseMove);
    return () => {
        console.log("cleared");
        canvas.removeEventListener("mousedown", handleMouseDown);
        canvas.removeEventListener("mouseup", handleMouseUp);
        canvas.removeEventListener("mousemove", handleMouseMove);
    }
}
const canvasEffectForPenCil = (canvas, color, cache, setCache) => {
    let isDrawing = false;
    const ctx = canvas.getContext("2d");
    const handleMouseDown = ({ offsetX, offsetY }) => {
        ctx.beginPath();
        ctx.strokeStyle = color;
        ctx.lineWidth = 1;
        ctx.moveTo(offsetX, offsetY);
        isDrawing = true;
    }
    const handleMouseMove = ({ offsetX, offsetY }) => {
        if (isDrawing) {
            ctx.lineTo(offsetX, offsetY);
            ctx.stroke();
        }
    }
    const handleMouseUp = () => {
        isDrawing = false;
        setCache([...cache, ctx.getImageData(0, 0, 1000, 500)]);
    }
    const handleMouseLeave = () => {
        isDrawing = false;
    }

    canvas.addEventListener("mousedown", handleMouseDown);
    canvas.addEventListener("mouseup", handleMouseUp);
    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseleave", handleMouseLeave);
    return () => {
        console.log("cleared");
        canvas.removeEventListener("mousedown", handleMouseDown);
        canvas.removeEventListener("mouseup", handleMouseUp);
        canvas.removeEventListener("mousemove", handleMouseMove);
        canvas.removeEventListener("mouseleave", handleMouseLeave);
    }
}

export const Canvas = ({ mode, color }) => {
    const canvasRef = useRef(null);
    const [cache, setCanvasCache] = useState([new ImageData(1000, 500)]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === "z" && cache.length >= 2) {
                const ctx = canvasRef.current.getContext("2d");
                ctx.putImageData(cache[cache.length - 2], 0, 0);
                setCanvasCache(cache.slice(0, cache.length - 1));
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        }
    }, [cache]);
    useEffect(() => {
        if (mode === 1)
            return canvasEffectForEraser(canvasRef.current, color, cache, setCanvasCache, 20);
        if (mode === 3)
            return canvasEffectForCircle(canvasRef.current, color, cache, setCanvasCache);
        if (mode === 4)
            return canvasEffectForLine(canvasRef.current, color, cache, setCanvasCache);
        if (mode === 2)
            return canvasEffectForRectangle(canvasRef.current, color, cache, setCanvasCache);
        // if (mode === 0)
        return canvasEffectForPenCil(canvasRef.current, color, cache, setCanvasCache);
        //else return canvasEffectForEraser(canvasRef.current, mode, color, setPath, setPaths, paths);
    }, [mode, color, cache]);

    return (
        <div className="back-div" >
            <canvas
                ref={canvasRef}
                width="1000px"
                height="500px"
                id="canvas1"
                className="paint-canvas"
            >
            </canvas>
        </div>
    )
}




